'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.textFontMenuWidget = function (mapEditorModel, fontFamilies) {
	if (!mapEditorModel || !fontFamilies) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const fontSelector = this;
		Object.keys(fontFamilies).forEach(fontFamily => {
			const fontComponent = mmWidgets('<menuitem>')
				.text(fontFamily)
				.on('click', () => {
					mapEditorModel.updateNodeStyles({'fontFamily': fontFamily});
				})
				.css({
					'font-family': fontFamilies[fontFamily]
				});
			fontSelector.append(fontComponent);
		});
	});

};

